<template>
  <div>
    <AssetReport :reportData="reportData" v-if="reportData" />
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import AssetReport from "../components/AssetReport";
import DefaultLayout from "../layouts/DefaultLayout";

export default {
  components: {
    AssetReport
  },
  data() {
    return {
      reportData: null,
      nextToken: null
    };
  },
  async created() {
    this.$emit(`update:layout`, DefaultLayout);
    this.nextToken = null;
    let report = [];
    report = await this.nextRecord();
    while (this.nextToken !== null) {
      let nextReport = await this.nextRecord();
      report.push(...nextReport);
    }
    this.reportData = report;
  },
  methods: {
    async nextRecord() {
      const listEquipmentLogBundles = /* GraphQL */ `
        query ListEquipmentLogBundles(
          $filter: ModelEquipmentLogBundleFilterInput
          $limit: Int
          $nextToken: String
        ) {
          listEquipmentLogBundles(
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
              name
              assigned
              createdAt
              isDeleted
              equipmentLogAsset(limit: 1000, filter: { isDeleted: { eq: 0 } }) {
                items {
                  id
                  product
                  category
                  hpReference
                  model
                  serial
                  purchaseDate
                  cost
                  password
                  deliverTo
                  maintenance
                  supplierLink
                  createdAt
                  deleteReason
                  isDeleted
                }
                nextToken
              }
            }
            nextToken
          }
        }
      `;

      const {
        data: { listEquipmentLogBundles: report }
      } = await API.graphql(
        graphqlOperation(listEquipmentLogBundles, {
          limit: 50,
          filter: { isDeleted: { eq: 0 } },
          nextToken: this.nextToken
        })
      );
      this.nextToken = report.nextToken;
      return report.items;
    }
  }
};
</script>
